import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantCashTransferServiceService,
  Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto,
} from '../../services/wealthlane-award-settlement-services';
import moment from 'moment';
import { DATE_FORMAT } from '../../constants/common';

const useGetCashTransferDashboard = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: any
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Array<Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto>
  | undefined,
  unknown
> => {
  const { transferStatusIds, companyIds, _force } = tableInfo;
  const getCashTransferDashboard = useQuery(
    ['getCashTransferDashboard', transferStatusIds, companyIds, _force],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceService.getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferDashboard(
          [transferStatusIds],
          undefined,
          undefined,
          undefined,
          companyIds
        )
      );
    },
    {
      select: (data) =>
        data?.map((item: any) => {
          return { ...item, requestDate: moment(item.requestDate).format(DATE_FORMAT) };
        }),
    }
  );

  return getCashTransferDashboard;
};

export default useGetCashTransferDashboard;
